import { object, string } from "yup";

export const initialValues = {
  username: "",
  password: "",
};

export const validationSchema = object().shape({
  username: string().required(),
  password: string().required(),
});
